import type { MouseEvent } from 'react';

import { useToast } from '@kcd/design-system';

import { useCurrentUser } from '~/domains/auth/queries';

const ADULT_ONLY_TOAST_MESSAGE = '19세 이상 성인 회원만 이용할 수 있는 상품이에요.';

/**
 * MKPC-3616: 성인전용(19금) 카테고리 상품 && 비성인(미성년/미인증) 뷰어일 때 true.
 * 상품 카드 썸네일에 19 배지 오버레이를 띄울지 결정한다.
 * (성인 여부는 BE BuyerResponse.adult, 상품 성인전용 여부는 SelectProductResponseV2.adultOnly)
 */
export function useShowAdultBadge(adultOnly?: boolean): boolean {
  const { user } = useCurrentUser();
  return !!adultOnly && user?.adult !== true;
}

/**
 * MKPC-3616: 목록에서 19금 상품을 비성인이 클릭했을 때 상세 진입을 막고 토스트를 띄운다.
 * 카드의 클릭 핸들러 첫 줄에서 `if (guardAdultClick(e)) return;` 형태로 사용한다.
 * 차단했으면 true(이동 막음), 아니면 false(정상 진행)를 반환한다.
 */
export function useAdultGuardClick(adultOnly?: boolean) {
  const blocked = useShowAdultBadge(adultOnly);
  const toast = useToast();

  return (e?: MouseEvent): boolean => {
    if (!blocked) return false;
    e?.preventDefault();
    e?.stopPropagation();
    toast(ADULT_ONLY_TOAST_MESSAGE, { offset: 86 });
    return true;
  };
}
